// extracted by css-extract-rspack-plugin
export default {"account":"account-RVHfRo"};